import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
	"@keyframes onloadup": {
		"0%": {
			opacity: 0,
			transform: "translateY(65px)"
		},
		"100%": {
			opacity: 1,
			transform: "translateY(0)"
		}
	},
	invoicesContainer: {
		background: '#F5F5F5',
		color: '#4a4a4a',
		fontSize: 16,
		letterSpacing: '-0.5px',
		height: '100%',
		padding: '34px 35px',
		animationName: `$onloadup`,
		animationDuration: '0.3s',
		animationFillMode: 'both',
		animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
		'& .MuiFormControlLabel-root': {
			marginBottom: 0
		},
		'@media(max-width: 1200px)': {
			paddingLeft: 110,
		},
		'@media(max-width: 768px)': {
			padding: 30,
		},
		'@media(max-width: 480px)': {
			padding: 20,
		}
	},
	invoicesContainerContent: {
		maxWidth: '1110px',
		position: 'relative',
		height: '100%'
	},
	invoiceLoader: {
		height: 371,
		position: 'relative'
	},
	invoiceLoaderSpinner: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		margin: 'auto',
	},
	emptyData: {
		boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
		backgroundColor: '#fff',
		textAlign: 'center',
		padding: '6em 1em',
		'& h3': {
			marginBottom: 10
		},
		'& p': {
			margin: 0
		}
	},
	filterContainer: {
		display: 'flex',
		'@media(max-width: 1024px)': {
			flexDirection: 'column',
			marginBottom: 30
		},
		'& .MuiButtonGroup-root': {
			'& button': {
				height: '45px'
			}
		}
	},
	filterRight: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		justifyContent: 'flex-end',
		justifySelf: 'flex-end',
		gap: 30,
		'@media(max-width: 1024px)': {
			justifyContent: 'flex-start'
		},
		'@media(max-width: 480px)': {
			display: 'block',
			marginBottom: 10,
			'& > div': {
				width: '100%',
			},
		},
	},
	downloadIcon: {
		marginRight: '6px',
		position: 'relative'
	},
	donwloadText: {
		textDecoration: 'none',
		color: '#2D91E9'
	},
	loadingIcon: {
		display: 'inline-block',
		marginRight: 15,
		verticalAlign: 'bottom'
	},
	downloadButton: {
		height: 18,
		padding: 0
	},
	legalEntityInput: {
		marginBottom:0
	},
	sectionHeaderInput: {
		'@media(max-width: 1024px)': {
			marginBottom: 0
		}
	},
	disableBottomMargin: {
		marginBottom: 0
	}
});
